var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("default-value") },
                    model: {
                      value: _vm.config.DefaultValue,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "DefaultValue", $$v)
                      },
                      expression: "config.DefaultValue",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            _vm._l(_vm.langs, function (lang) {
              return _c(
                "w-col",
                { key: lang, attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: {
                      label: _vm.$ct("extra-field-bool-yes-text-lang", {
                        lang,
                      }),
                      fancy: "",
                    },
                    model: {
                      value: _vm.config.DocumentYesText.Translations[lang],
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.config.DocumentYesText.Translations,
                          lang,
                          $$v
                        )
                      },
                      expression: "config.DocumentYesText.Translations[lang]",
                    },
                  }),
                ],
                1
              )
            }),
            1
          ),
          _c(
            "w-row",
            _vm._l(_vm.langs, function (lang) {
              return _c(
                "w-col",
                { key: lang, attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: {
                      label: _vm.$ct("extra-field-bool-no-text-lang", { lang }),
                      fancy: "",
                    },
                    model: {
                      value: _vm.config.DocumentNoText.Translations[lang],
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.config.DocumentNoText.Translations,
                          lang,
                          $$v
                        )
                      },
                      expression: "config.DocumentNoText.Translations[lang]",
                    },
                  }),
                ],
                1
              )
            }),
            1
          ),
          _c("app-extra-field-base-options", {
            attrs: {
              value: _vm.config,
              "extra-fields-type": _vm.extraFieldsType,
            },
          }),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }